import IntelligenceWorkbench from '../components/IntelligenceWorkbench';

/** Keep the existing LLM URL while sharing the complete analysis workspace. */
export default function LLMIntelligence() {
  return <IntelligenceWorkbench/>;
}
